import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logoIcon from "./logo-removebg.png";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(false); // Tracks mobile or responsive view
  const [showMenu, setShowMenu] = useState(false); // Tracks whether to show nav-links

  // Function to toggle the menu on mobile
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  // Adjust navbar dynamically based on screen width
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize(); // Run once on mount
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <nav className="navbar">
      {/* Logo */}
      <div className="logo">
        <img src={logoIcon} alt="Logo Icon" className="logo-icon" />
        SoIK <sup>®</sup>
      </div>

      {/* Hamburger Menu */}
      {isMobile && (
        <button className="hamburger" onClick={toggleMenu}>
          ☰
        </button>
      )}

      {/* Navigation Links */}
      <ul className={`nav-links ${isMobile && showMenu ? "active" : ""}`}>
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#about">About Us</a>
        </li>
        <li>
          <a href="#purpose">Purpose</a>
        </li>
        <li>
          <a href="#gallery">Image Gallery</a>
        </li>
        <li>
          <a href="#contact">Contact Us</a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;